export default __webpack_public_path__ + "static/app-features-4-457617ac41f2b0a7a0231e24b35992ad.webp";